// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__c_qkw","mapImg":"Map_mapImg__mHJuZ"};